import * as classnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import FeatureContainer from '../../../containers/feature'

import TrendingSash from '../../../components/trendingSash'
import ItemCardAudioContent from '../itemCardAudioContent'
import ItemCardSmallSidebar from '../itemCardSmallSidebar'

import * as styles from './audioJungleItemCard.module.css'

class AudioJungleItemCard extends React.Component<IItemCard> {
  public render() {
    const { item, viewType } = this.props

    const rootClass = classnames(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <div className={rootClass}>
        <article className={styles.card}>
          {item.trending && <TrendingSash lazy />}
          <ItemCardAudioContent {...this.props} />
          <div className={styles.sidebar}>
            <ItemCardSmallSidebar {...this.props} />
          </div>
        </article>
      </div>
    )
  }
}

export default AudioJungleItemCard
